exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "@media(max-width:600px){.resort-humming-bird-container[data-v-fd68d322] .resort-item-loading-large{display:flex;flex-direction:column;row-gap:1rem}}.best-price-guarantee-box[data-v-fd68d322]{border:1.5px solid var(--discount-primary);color:var(--discount-primary);border-radius:12px}.best-price-guarantee-box svg[data-v-fd68d322]{fill:var(--discount-primary)}", ""]);

// exports
